import { render, staticRenderFns } from "./KT-GanttChart.vue?vue&type=template&id=1929a4c2&scoped=true&"
import script from "./KT-GanttChart.vue?vue&type=script&lang=js&"
export * from "./KT-GanttChart.vue?vue&type=script&lang=js&"
import style0 from "./KT-GanttChart.vue?vue&type=style&index=0&id=1929a4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929a4c2",
  null
  
)

export default component.exports